import { FC, ReactNode, useEffect } from 'react';
import { Form as FormReact } from 'react-final-form';
import { ObjectSchema } from 'yup';
import arrayMutators from 'final-form-arrays';
import { Decorator, Mutator } from 'final-form';
import { Container } from './styles';

export interface IForm {
  initialValues?: object;
  schema: ObjectSchema<any>;
  decorators?: Decorator[];
  mutators?: { [key: string]: Mutator };
  className?: string;
  children?: ReactNode | ((formProps: any) => ReactNode);
  isSubmited?: boolean;
  resetForm?: boolean;
  onSubmit: (values?: any, erros?: string[]) => void;
}

const Form: FC<IForm> = ({
  initialValues,
  schema,
  decorators,
  className,
  mutators,
  children,
  isSubmited,
  resetForm,
  onSubmit,
}) => {
  let formProps: any;

  useEffect(() => {
    if (isSubmited && formProps) {
      formProps.form.submit();
    }
  }, [isSubmited, formProps]);

  const validateForm = async (values: any) => {
    try {
      return (await schema.validate(values, { abortEarly: false })) === null;
    } catch (error: any) {
      const errors = error.inner.reduce(
        (formError: any, innerError: any) => ({
          ...formError,
          [innerError.path]: innerError.message,
        }),
        {},
      );
      if (isSubmited) {
        onSubmit(undefined, []);
      }
      return errors;
    }
  };

  return (
    <Container className={className || ''}>
      <FormReact
        onSubmit={(values) => onSubmit(values)}
        initialValues={initialValues}
        mutators={{
          ...arrayMutators,
          ...mutators,
          addValue: ([name, val], state, { changeValue }) => {
            changeValue(state, name, (value) => (value = val));
          },
        }}
        decorators={[...(decorators || [])]}
        validate={validateForm}
      >
        {(props) => {
          formProps = props;
          return (
            <form onSubmit={(e) => {
              props.handleSubmit(e);
              if (resetForm) {
                props.form.reset();
                Object.keys(props.values).forEach((key) => {
                  props.form.resetFieldState(key);
                });
              }
            }}>
              {typeof children === 'function' ? children(formProps) : children}
            </form>
          );
        }
        }
      </FormReact>
    </Container>
  );
};

export default Form;
